__turbopack_context__.v({
  "coverImageBanner": "_6RpuHa_coverImageBanner",
  "coverImageBannerHeight": "_6RpuHa_coverImageBannerHeight",
  "list_block": "_6RpuHa_list_block",
  "logo": "_6RpuHa_logo",
  "richtext": "_6RpuHa_richtext",
});
